<template>
	<div class="offer-card">
		<div class="offer-card__image" @click="openPopup(offer)">
			<div class="label flex al-center">
				<template v-for="(label, indx) in getLabel(_.get(offer, 'store_labels'))">
					<div
						v-if="_.get(label, 'title')"
						class="label-item"
						:style="{ background: _.get(label, 'color.color') }"
						:key="indx"
					>
						{{ _.get(label, 'title') }}
					</div>
				</template>
			</div>

			<picture>
				<source
					media="(max-width: 767px)"
					:srcset="`${_.get(offer, 'cover_image[0].devices.mobile')}`"
				/>
				<source
					media="(max-width: 1023px)"
					:srcset="`${_.get(offer, 'cover_image[0].devices.tablet')}`"
				/>
				<img :src="_.get(offer, 'cover_image[0].devices.desktop')" alt="image" />
			</picture>
		</div>
		<div class="offer-card__content">
			<div class="title font-34 light uppercase text-overflow-hidden-2">
				{{ _.get(offer, 'front_title') }}
			</div>
			<div class="teaser  uppercase bold">
				{{ _.get(offer, 'teaser') }}
			</div>
			<a href="javascript:void(0)" @click="openPopup(offer)" class="visit uppercase pointer bold">
				{{ $fn.tr('ვრცლად') }}
				<svg xmlns="http://www.w3.org/2000/svg" width="7.857" height="10" viewBox="0 0 7.857 10">
					<path
						id="Icon_material-play-arrow"
						data-name="Icon material-play-arrow"
						d="M12,7.5v10l7.857-5Z"
						transform="translate(-12 -7.5)"
						fill="#4d4d4f"
					/>
				</svg>
			</a>
		</div>
	</div>
</template>

<script>
import StorePopup from '../modals/StorePopup.vue';

export default {
	props: ['contentData', 'offer'],
	components: {
		StorePopup,
	},
	methods: {
		openPopup(data) {
			console.log(123, '123');
			this.$store.commit('main/setState', { key: 'store_pop_up', val: true });
			this.$store.commit('main/setState', {
				key: 'store_modal_data',
				val: data,
			});
		},

		getLabel(labelId) {
			const floorWidget = this.$store.state.main?.indx?.terms?.store_labels;
			const res = [];
			labelId && labelId.length
				? labelId.forEach((label) => {
						res.push(floorWidget.find((item) => item.id == label));
				  })
				: '';
			return res;
		},
	},
};
</script>

<style lang="scss">
.offer-card {
	&__image {
		width: 100%;
		height: 377px;
		position: relative;
		overflow: hidden;
		cursor: pointer;
		background: $white;
		z-index: 99;

		&:hover {
			img {
				transform: scale(1.1, 1.1);
			}
		}
		// @media (max-width: 1599px) {
		// 	height: 275px;
		// }
		@media (max-width: 1023px) {
			height: 355px;
		}
		@media (max-width: 767px) {
			height: auto;
			padding-top: 50%;
		}
		.label {
			position: absolute;
			top: 30px;
			left: 30px;

			.label-item {
				padding: 10px;
				height: 28px;
				display: flex;
				align-items: center;
				border-radius: 10px;
				z-index: 2;
				background: $yellow;
				color: $white;
				margin-right: 10px;
				font-size: 13px;
			}
			@media (max-width: 1023px) {
				top: 21px;
				left: 21px;
			}
		}
		img {
			width: 100%;
			height: 100%;
			position: absolute;
			object-fit: cover;
			transition: 0.3s linear;
			transform-origin: center center;
			@media (max-width: 1023px) {
				// object-fit: contain;
			}

			@media (max-width: 767px) {
				top: 0;
			}
		}
	}
	&__content {
		padding-left: 28px;
		padding-top: 30px;
		@media (max-width: 767px) {
			padding-left: 0px;
		}
		.title {
			color: $black;
			margin-bottom: 20px;
			height: 80px;
			@media (max-width: 767px) {
				font-size: 21px;
				height: 50px;
			}
		}
		.teaser {
			color: #4d4d4f;
			margin-bottom: 34px;
		}
		.visit {
			color: $black;

			svg {
				margin-left: 10px;
				path {
					transition: 0.4s ease;
				}
			}
			transition: 0.4s ease;
			&:hover {
				color: $red;
				svg {
					path {
						fill: $red;
					}
				}
			}
		}
	}
}
</style>
